import React from "react";
import PropTypes from "prop-types";
import { SvgIcon } from "@mui/material";

const propTypes = {
	fontSize: PropTypes.oneOf(["inherit", "default", "small", "large"]),
	handleMouseEnter: PropTypes.func,
	handleMouseLeave: PropTypes.func,
	customStyles: PropTypes.shape({
		width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	})
};

const defaultProps = {
	customStyles: {
		width: 24,
		height: 24
	}
};

const Target = ({ handleMouseEnter, handleMouseLeave, customStyles }) => {
	const { width, height } = customStyles;

	return (
		<SvgIcon onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{ width, height }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
				<title>targeting-icon</title>
				<circle cx="12" cy="12" r="10.5" fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="2.5" />
				<line x1="2" y1="12" x2="7" y2="12" fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="2.5" />
				<line
					x1="17"
					y1="12"
					x2="22"
					y2="12"
					fill="none"
					stroke="#fff"
					strokeMiterlimit="10"
					strokeWidth="2.5"
				/>
				<line x1="12" y1="2" x2="12" y2="7" fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="2.5" />
				<line
					x1="12"
					y1="17"
					x2="12"
					y2="22"
					fill="none"
					stroke="#fff"
					strokeMiterlimit="10"
					strokeWidth="2.5"
				/>
			</svg>
		</SvgIcon>
	);
};

Target.propTypes = propTypes;
Target.defaultProps = defaultProps;

export default Target;
